import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  alertContainer: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: theme.colors.yellow[4],
    textAlign: 'center',
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
    borderRadius: theme.other.spacing._4,
  },
  promoCardSection: {
    paddingTop: theme.other.spacing._24,
    width: '100%',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },
  promoCardContainer: {
    maxWidth: 400,
    width: '100%',
  },
  voucherWarningContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    width: '100%',
    maxWidth: 400,
    color: theme.colors.gray2[3],

    '& > svg': {
      display: 'block',
      minWidth: 16,
    }
  },

  contestCardSection: {
    padding: `${theme.other.spacing._32}px 0`,
    display: 'flex',
    justifyContent: 'center',
  },
  contestCardContainer: {
    maxWidth: 400,
    width: '100%',
  },

  zipGateSection: {
    width: '100%',
    maxWidth: 400,
    margin: '0 auto',
    marginBottom: theme.other.spacing._24,
  },
  verificationCard: {
    width: '100%',
    background: theme.white,
    boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: theme.other.spacing._16,
    padding: `${theme.other.spacing._12}px ${theme.other.spacing._16}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._16,
  },
  zipInput: {
    width: '100%',
  },
  zipTermsLabel: {
    marginLeft: theme.other.spacing._4,
  },
  zipTermsLink: {
    padding: 0,
    height: 'auto',
  },
  disabledContent: {
    pointerEvents: 'none',
    opacity: 0.45,
  },
  numberInputContainer: {
    [theme.fn.smallerThan('md')]: {
      width: '100%',
      flexGrow: 1,
    },
  },
  numberInput: {
    width: 80,
    height: 40,
    textAlign: 'center',
    borderRadius: theme.other.spacing._8,
    borderColor: theme.colors.gray2[1],
  },
  footer: {
    display: 'flex',
    justifyContent: 'stretch',
    alignItems: 'start',
    width: '100%',
    marginTop: theme.other.spacing._16,

    [theme.fn.smallerThan('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing.md,
      textAlign: 'center',
    },
  },
  ctaWrapper: {
    width: '100%',
  },
  cta: {
    width: '100%',
  },
  creditsSelectionSection: {
    width: '100%',
    margin: `${theme.other.spacing._16}px auto 0`,
  },
}));

export default useStyles;
